/**
 * Environment Configuration
 * 
 * Centralizes all environment-specific configuration
 * Provides type-safe access to environment variables
 */

const config = {
  // Environment - use NODE_ENV for React apps (set by react-scripts)
  env: process.env.NODE_ENV || 'development',

  // Base Route Configuration
  // Development: empty (localhost:3000/)
  // Production: /sjvn_frontend (for GoDaddy deployment in public_html/sjvn_frontend)
  baseRoute: process.env.PUBLIC_URL || '',

  // API Configuration
  // Development: uses proxy (relative URL) to avoid CORS issues
  // Production: production API (https://i5l.95d.mytemp.website/api) - backend in vigilence_backend folder
  api: {
    baseURL: process.env.NODE_ENV === 'production'
      ? (process.env.REACT_APP_API_BASE_URL_PROD || 'https://sjvn.nic.in/vigilancebackend/api')
      : (process.env.REACT_APP_API_BASE_URL_DEV || 'https://sjvn.nic.in/vigilancebackend/api'), // Use relative URL in dev to leverage proxy
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
    enableLogging: process.env.REACT_APP_ENABLE_API_LOGGING === 'true',
  },

  // Feature Flags
  features: {
    enableMockData: process.env.REACT_APP_ENABLE_MOCK_DATA === 'true',
  },

  // Get current environment
  isDevelopment: () => config.env === 'development',
  isProduction: () => config.env === 'production',
  isTest: () => config.env === 'test',
};

// Validate required configuration
const validateConfig = () => {
  const required = ['api.baseURL'];
  const missing = [];

  required.forEach(key => {
    const keys = key.split('.');
    let value = config;

    for (const k of keys) {
      value = value[k];
      if (!value) {
        missing.push(key);
        break;
      }
    }
  });

  if (missing.length > 0) {
    console.error('Missing required configuration:', missing);
  }
};

// Run validation on load
validateConfig();

export default config;

